export default __webpack_public_path__ + "static/media/quickBooksDesktop.d87294e6.svg";